import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";


const initialState = {
  value: [],
  loading: false,
};

export const updateRoutineRedraws = createAsyncThunk(
  "routineRedraws/updateRoutineRedraws",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateRoutineRedrawsSlice = createSlice({
  name: "updateRoutineRedraws",
  initialState,
  reducers: {
    clearUpdateRoutineRedrawsResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateRoutineRedraws.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRoutineRedraws.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateRoutineRedraws.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateRoutineRedrawsList = (state) => state.updateRoutineRedraws.value;
export const updateRoutineRedrawsLoader = (state) => state.updateRoutineRedraws.loading;
export const { clearUpdateRoutineRedrawsResponse } = updateRoutineRedrawsSlice.actions;

export default updateRoutineRedrawsSlice.reducer;
